/* eslint-disable no-console */
/* eslint-disable react/no-unstable-nested-components */
import React, { useCallback, useEffect, useState } from "react";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import CustomTable from "../../../../Core/Components/CustomTable";
import { paymentTransactionColumns } from "./data";
import { FinanceHoverIcon } from "../../../../Common/Svgs/FinanceIcon";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";
import { updateRevenue } from "../../../../Redux/Slices/revenue.slice";
import { client } from "../../../../Utils/axiosClient";

const LOCAL_DEFAULT_LIMIT = 10;

const TransactionHistoryDrawer = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const { selectedPayment } = useSelector((state) => state.revenue);

  const [currentPage, setCurrentPage] = useState(1);
  const [transactionHistory, setTransactionHistory] = useState({
    result: [],
    totalRecords: 0,
  });

  const getTransactionHistory = useCallback(
    async (filterObj) => {
      try {
        dispatch(
          updateRevenue({
            key: "loading",
            value: true,
          }),
        );

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/revenue/get-completed-payments`,
          { params: filterObj },
        );

        const { result, totalRecords } = response.data;

        setTransactionHistory({
          result,
          totalRecords,
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(
          updateRevenue({
            key: "loading",
            value: false,
          }),
        );
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const filterObj = {
      entityId: selectedPayment?.entityId,
      entityType: selectedPayment?.entityType,
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      limit: (currentPage || 1) * LOCAL_DEFAULT_LIMIT,
    };

    if (visible) getTransactionHistory(filterObj);
  }, [visible, selectedPayment, currentPage, getTransactionHistory]);

  return (
    <Drawer
      width={448}
      placement="right"
      closable={false}
      maskStyle={{
        background: "transparent",
        boxShadow: "12px 12px 16px -4px #10182814",
      }}
      open={visible}
      onClose={onCancel}
      className="rounded-tl-xl"
    >
      <div className="bg-background-white w-full h-full rounded-tl-xl">
        <div className="p-6">
          <div className="flex items-center justify-between">
            <p className="font-poppins font-medium text-base text-black">
              Transaction History
            </p>

            <CloseIcon
              className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
              onClick={onCancel}
            />
          </div>
        </div>

        <div className="transaction-history max-h-[calc(100%-120px-24px)] overflow-y-scroll">
          <CustomTable
            columns={paymentTransactionColumns}
            data={transactionHistory.result}
            scrollX={null}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: transactionHistory.totalRecords,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                const lastPage = transactionHistory.totalRecords / current;

                if (type === "prev" && current === 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "prev" && current > 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next" && lastPage <= 10) {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{ pointerEvents: "none" }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next") {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                return originalElement;
              },
            }}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default TransactionHistoryDrawer;
